import LadzoDropDownMenu from "../global/ladzoDropDownMenu.js";
import { LadzoConsole as Lc } from "../global/ladzo-console.js";

export function zah_dropdownKlient() {
  Lc.f("zah_dropdownKlient");

  //$("#btDropdown").ladzoDropDownMenu({ menu: "#ulTopDropdown" });

  new LadzoDropDownMenu("#btDropdown", { menu: "#ulTopDropdown" });
}
